import AddButton from './common/add.button'
import EditButton from './common/edit.button'
import RedirectButton from './common/redirect.button'
import RefreshButton from './common/refresh.button'
import RemoveButton from './common/remove.button'
import StorageRuleButton from './storage-rule.button'
import StorageTransactionButton from './storage-transaction.button'

export const Buttons = {
  Add: AddButton,
  Edit: EditButton,
  Remove: RemoveButton,
  Redirect: RedirectButton,
  Refresh: RefreshButton,
  StorageRule: StorageRuleButton,
  StorageTransaction: StorageTransactionButton,
}
